import React from 'react';

import l10n from "../../l10n/localization";

import {Button, NavItem} from "react-materialize";
import ClientTabs from "./ClientTabs";
import sematable, {Table} from "sematable";
import Dropdown from "../common/Dropdown";
import * as creationActions from "../../actions/creation";
import * as clientActions from '../../actions/client';
import Dialog from "react-toolbox/lib/dialog/Dialog";

export const CLIENTS_TABLE = 'CLIENTS_TABLE';

const columns = [
    {key: 'id', primaryKey: true, hidden: true},
    {key: 'name', header: l10n.client.name, searchable: true, filterable: true, sortable: true},
    {key: 'currencyName', header: l10n.client.currency, searchable: true, filterable: true, sortable: true},
    {key: 'address', header: l10n.client.address, searchable: true, filterable: true},
    {key: 'gitCode', header: l10n.client.gitCode, searchable: true, filterable: true, sortable: true},
    {key: 'phone', header: l10n.client.phone, searchable: true, filterable: true},
    {key: 'fax', header: l10n.client.fax},
    {key: 'email', header: l10n.client.email, searchable: true, filterable: true, sortable: true},
    {key: 'vatRate', header: l10n.client.vatRate, sortable: true},
    {key: 'comments', header: l10n.client.comments},
    {key: 'actions', header: l10n.client.actions}
];

class ClientTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            clientID: null,
            dialogActive: false
        };
    }

    handleDelete = () =>{
        this.props.dispatch(clientActions.deleteClient(this.state.clientID));
    };

    addActions() {
        this.props.columns[this.props.columns.length - 1].Component = ({row}) => {
            return (
                <div className="fog-table-buttons">
                    <Button floating onClick={() => this.props.handleClick(ClientTabs, {item: row}, creationActions.destroyingnewlyCreatedClient())} icon="edit" className="edit-button" />
                    {<Dropdown trigger={(props) => (
                        <Button floating icon="more_vert" className="more-button" onClick={props.onClick}/>)}>
                        <NavItem>
                            <Button disabled={this.props.deletetingClient} className="transparent" onClick={() => this.setState({...this.state, dialogActive: true, clientID: row.id})} >
                                {l10n.common.remove}
                            </Button>
                        </NavItem>
                    </Dropdown>}
                </div>
            )
        };
    }

    render() {
        this.addActions();

        return (
            <div>
                <Table
                    {...this.props}
                />
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, clientID: null}) },
                        { label: "Yes", onClick: () => this.handleDelete() }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this client ?</p>
                </Dialog>
            </div>
        )
    }
}

export default sematable(CLIENTS_TABLE, ClientTable, columns, {
    defaultPageSize: 70,
    autoHidePagination: true,
    showPageSize: false
});

/*

    {<Table bordered>
        <thead>
        <tr>
            <th data-field="name">{l10n.client.name}</th>
            <th data-field="currency">{l10n.client.currency}</th>
            <th data-field="address">{l10n.client.address}</th>
            <th data-field="git_code">{l10n.client.gitCode}</th>
            <th data-field="phone">{l10n.client.phone}</th>
            <th data-field="fax">{l10n.client.fax}</th>
            <th data-field="email">{l10n.client.email}</th>
            <th data-field="vat_rate">{l10n.client.vatRate}</th>
            <th data-field="comments">{l10n.client.comments}</th>
            <th data-field="actions">{l10n.client.actions}</th>
        </tr>
        </thead>

        <tbody>
        {this.props.clients.map((item, index) => (
            <ClientItem item={item} key={index} client={this.props.client} mappedCurrencies={this.props.currencies} openDrawer={this.props.handleClick} />
        ))}
        </tbody>
    </Table>}
 */


// WEBPACK FOOTER //
// ./src/components/client/ClientTable.js